import * as React from 'react';

function SvgNoListing(props) {
  return (
    <svg viewBox="0 0 13 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="#F25202">
        <path d="M1.614 11.484a.495.495 0 01-.493-.494V4.14l-.387.224a.516.516 0 01-.247.064.476.476 0 01-.422-.247.493.493 0 01.176-.67L6.204.063A.516.516 0 016.45 0h.1c.084 0 .168.021.246.063l5.963 3.448a.492.492 0 01-.494.853L6.5 1.03 2.1 3.576v6.936h2.126a.495.495 0 010 .988H1.614v-.016z" />
        <path d="M9 5C7.07 5 5.5 6.57 5.5 8.5S7.07 12 9 12c1.928 0 3.5-1.57 3.5-3.5S10.93 5 9 5zm2.576 3.5a2.56 2.56 0 01-.442 1.441L7.56 6.364A2.566 2.566 0 019 5.923a2.58 2.58 0 012.575 2.576zm-5.152 0c0-.534.162-1.03.442-1.442l3.576 3.576a2.566 2.566 0 01-1.441.442A2.58 2.58 0 016.424 8.5z" />
      </g>
    </svg>
  );
}

export default SvgNoListing;
